import { AppIcon, LogoBlock } from "../components/InstateamEmployeeComponents";

export default function EmployeeAccessDeniedPage({ employee, onBackToLogin }) {
  return (
    <div className="employee-shell">
      <section className="employee-access-card">
        <div className="employee-access-card-inner">
          <LogoBlock
    subtitle="HRMS & Management"
    logo="/instateamlogo2.png"
  />

          <div className="access-denied-icon">
            <AppIcon name="shieldLock" />
          </div>

          <div className="access-denied-copy">
            <span className="access-denied-eyebrow">Employee Access</span>
            <h1>Access Denied</h1>
            <p>
              This employee account is currently inactive. Contact admin to restore
              access to the employee panel.
            </p>
          </div>

          {employee ? (
            <div className="access-denied-meta">
              <div>
                <span>Employee</span>
                <strong>{employee.fullName || "Restricted Employee"}</strong>
              </div>
              <div>
                <span>Username</span>
                <strong>{employee.username || "—"}</strong>
              </div>
              <div>
                <span>Status</span>
                <strong>{employee.status || "inactive"}</strong>
              </div>
            </div>
          ) : null}

          <button className="primary-button full-width" type="button" onClick={onBackToLogin}>
            Back to Login
          </button>

          <p className="employee-footer">© 2025 Insta Team. All rights reserved.</p>
        </div>
      </section>
    </div>
  );
}
